import { memo } from "react";
import { View, Text } from "@src/components";
import { RoutinePreview } from "./RoutinePreview";
import type { FC } from "react";
import type { AlarmRoutine } from "@src/services/api/types";

interface CurrentRoutinesProps {
  routines: AlarmRoutine[];
  onEdit: (routine: AlarmRoutine) => void;
}

export const CurrentRoutines: FC<CurrentRoutinesProps> = memo(({ routines, onEdit }) => {
  if (routines.length === 0) return null;

  return (
    <View px="5xl" pt="4xl">
      <Text textStyle="xs/medium" color="textMuted" mb="lg">
        Current
      </Text>
      {routines.map((routine, index) => (
        <View key={index} mb="lg">
          <RoutinePreview routine={routine} accessoryIcon="edit" onPress={() => onEdit(routine)} />
        </View>
      ))}
    </View>
  );
});

CurrentRoutines.displayName = "CurrentRoutines";
